<template>
  <button :disabled="disabled" title="delete" class="btn delete-btn">
    <img src="@/assets/icons/ui/trash-outline-red.svg" alt="delete" />
  </button>
</template>

<script>
export default {
  name: "DeleteButton",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
